export interface ProblemDetails {
  type?: string
  title?: string
  status?: number
  detail?: string
  instance?: string
  errors?: Record<string, string[]>
  [key: string]: unknown
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly problem: ProblemDetails,
    /**
     * Seconds the server asked the caller to wait before retrying, from the
     * `Retry-After` header. Present on a 429 from the API's rate limiter;
     * undefined when the server sent nothing, which is not the same as zero —
     * a retrying caller falls back to its own backoff rather than hammering.
     */
    public readonly retryAfterSeconds?: number,
  ) {
    super(problem.title ?? `HTTP ${status}`)
    this.name = 'ApiError'
  }
}
